import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';

import ErrorBoundary from './components/ErrorBoundary';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { BrandingProvider } from './contexts/BrandingContext';
import { ConfirmProvider } from './contexts/ConfirmContext';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Patienten from './pages/Patienten';
import PatientDetail from './pages/PatientDetail';
import Chat from './pages/Chat';
import Eingang from './pages/Eingang';
import Pruefen from './pages/Pruefen';
import Admin from './pages/Admin';
import BetreiberKonsole from './pages/BetreiberKonsole';
import Profil from './pages/Profil';
import Arbeitstisch from './pages/Arbeitstisch';

// Fork von powerCONTACT/App.tsx (2026-09-04): ohne SIP, ohne AgentsLoader,
// ohne OIDC-Callback-Seite — der Login-Rueckweg landet beim Backend, das das
// Session-Cookie setzt und auf die App weiterleitet.

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1 } },
});

// Rollen ohne Aktenzugriff (pflege, user) starten im Chat statt auf der Uebersicht (07.09.)
// admin.powercare.cloud = Betreiber-Konsole (Mandantenverwaltung), kein Praxis-Arbeitsplatz (Christian 08.09.)
export const istAdminPortal = typeof window !== 'undefined' && window.location.hostname.startsWith('admin.');

function Startseite() {
  const { user, canSeeAkten } = useAuth();
  return user && !canSeeAkten ? <Navigate to="/chat" replace /> : <Dashboard />;
}

export default function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Router>
          <BrandingProvider>
          <AuthProvider>
            <ConfirmProvider>
              <ScrollToTop />
              <Routes>
                <Route path="/login" element={<Login />} />
                {istAdminPortal ? (
                  <Route path="/*" element={<ProtectedRoute><BetreiberKonsole /></ProtectedRoute>} />
                ) : (
                <Route path="/*" element={
                  <ProtectedRoute>
                    <div className="min-h-screen bg-gray-50">
                      <Layout>
                        <Routes>
                          <Route path="/" element={<Startseite />} />
                          <Route path="/patienten" element={<Patienten />} />
                          <Route path="/patienten/:id" element={<PatientDetail />} />
                          <Route path="/chat" element={<Chat />} />
                          <Route path="/arbeitstisch" element={<Arbeitstisch />} />
                          <Route path="/eingang" element={<Eingang />} />
                          <Route path="/eingang/pruefen" element={<Pruefen />} />
                          <Route path="/admin" element={<Admin />} />
                          <Route path="/profil" element={<Profil />} />
                          <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                      </Layout>
                    </div>
                  </ProtectedRoute>
                } />
                )}
              </Routes>
              <Toaster position="top-right"
                toastOptions={{ duration: 4000, style: { background: '#363636', color: '#fff' } }} />
            </ConfirmProvider>
          </AuthProvider>
          </BrandingProvider>
        </Router>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
